// React Imports
import { forwardRef } from 'react'

// React Router Imports
import { Link as RRLink, type LinkProps } from 'react-router-dom'

// Type Imports
import type { ChildrenType } from '../types'

type RouterLinkProps = LinkProps &
  Partial<ChildrenType> & {
    className?: string
  }

const RouterLink = forwardRef((props: RouterLinkProps, ref: any) => {
  // Props
  const { to, className, ...other } = props

  return (
    <RRLink ref={ref} to={to} className={className} {...other}>
      {props.children}
    </RRLink>
  )
})

export default RouterLink
